module.exports = __webpack_public_path__ + "static/media/faCopy.f37cda86.svg";